/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import { environment } from "../../environment";
import IAppDownloadContext, { Datei } from "./IAppDownloadContext";

interface AppDownloadContextInstanceState {
    dateien: Datei[];
    update: number;
}

export default class AppDownloadContextInstance implements IAppDownloadContext {
    private readonly _setState: React.Dispatch<React.SetStateAction<AppDownloadContextInstanceState>>;
    private readonly _state: AppDownloadContextInstanceState;

    public constructor() {
        [this._state, this._setState] = useState<AppDownloadContextInstanceState>({
            dateien: [],
            update: 0,
        });
    }

    public get defaultUrl() {
        return environment.baseUrl;
    }

    public get dateien() {
        const dateien = this._state.dateien.map(d => d);
        this._setState({
            dateien: [],
            update: 0,
        })
        return dateien;
    }

    public get update() {
        return this._state.update;
    }

    public ladeHerunter = (url: string, dateiName: string) => {
        this._setState((prevState) => ({
            dateien: prevState.dateien.concat([{ url: url, dateiName: dateiName }]),
            update: prevState.update + 1 }));
    }

    public oeffneInTab = (url: string, dateiName: string) => {
        this._setState((prevState) => ({
            dateien: prevState.dateien.concat([{ url: url, dateiName: dateiName }]),
            update: prevState.update + 1 }));
    }
}